import { RecordContainer, useTitleChange, WorkflowNav } from '@msaf/core-react'
import { WellMode } from '../../../../../../../types/routing-types'
import HistoryDetails, { getWellHistoryLinks } from '../../../../../../components/well-forms/history/details'
import { useParamsOr404 } from '../../../../../../hooks/use-params-or-404'

export default function ViewWellHistoryDetails() {
  useTitleChange('View Well | History details')
  const { id, historyId } = useParamsOr404('id', 'historyId')
  return (
    <RecordContainer
      workflowNav={<WorkflowNav sections={[{ links: getWellHistoryLinks(id, historyId, WellMode.VIEW) }]} />}
    >
      <HistoryDetails />
    </RecordContainer>
  )
}
